import { render, staticRenderFns } from "./FloatingMenu.vue?vue&type=template&id=62470070&"
import script from "./FloatingMenu.vue?vue&type=script&lang=ts&"
export * from "./FloatingMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingMenu.vue?vue&type=style&index=0&id=62470070&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports